import React, { Component } from "react";
import { Modal, Button, Popup, Icon } from "semantic-ui-react";

import ErrorMessage from "../components/ErrorMessage";
import PositiveMessage from "../components/PositiveMessage";
import CreateUserForm from "../components/CreateUserForm";

import { connect } from "react-redux";

class CreateUserModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      team: this.props.toTeam,
      newName: "",
      newEmail: "",
      newUsername: "",
      newPassword: "",
      newLinkWeb: "",
      newOrg: "",
      newRole: "",
      newPermissions: "",
      userCreated: false,
      addedToTeam: false,
      error: false,
      loading: false,
      userDuplicateKey: false,
    };
  }
  newNameChange(e) {
    this.setState({ newName: e.target.value });
  }
  newEmailChange(e) {
    this.setState({ newEmail: e.target.value });
  }
  newOrgChange(e) {
    this.setState({ newOrg: e.target.value });
  }
  newLinkWebChange(e) {
    this.setState({ newLinkWeb: e.target.value });
  }
  newUsernameChange(e) {
    this.setState({ newUsername: e.target.value });
  }
  newPassChange(e) {
    this.setState({ newPassword: e.target.value });
  }
  selectRole(e, data) {
    let permissions = this.props.roles.filter((role) => {
      if (role.id === data.value) return role;
    });
    this.setState({
      newRole: data.value,
      newPermissions: permissions[0].role_permissions,
    });
  }
  createUser() {
    // const defaultPermission = {
    //   can_manage_user: false,
    //   can_manage_team: false,
    //   can_create_team: false,
    //   can_manage_staff: false,
    //   can_manage_profile: false,
    //   can_manage_project: true,
    //   can_manage_preload: false,
    //   can_upload_symbol: true,
    //   can_upload_media: true,
    //   can_access_admin: false,
    //   can_approve_symbol: false,
    //   can_create_project: true,
    //   can_read_project: true,
    //   can_update_project: true,
    //   can_share_project: false,
    //   can_delete_project: true,
    //   can_create_profile: false,
    //   can_read_profile: true,
    //   can_update_profile: true,
    //   can_delete_profile: true,
    //   can_show_filter: true,
    // };

    let myHeaders = new Headers();
    myHeaders.append("Content-type", "application/json");
    myHeaders.append("cache-control", "no-cache");

    let userxteam_data;
    if (this.state.team === 1) {
      userxteam_data = [
        {
          idteam: this.state.team,
          user_permissions: this.state.newPermissions,
          role_id: this.state.newRole,
        },
      ];
    } else {
      userxteam_data = [
        {
          idteam: this.state.team,
          user_permissions: this.state.newPermissions,
          role_id: this.state.newRole,
        },
        // {
        //   idteam: 1,
        //   user_permissions: JSON.stringify(defaultPermission),
        //   role_id: 4,
        // },
      ];
    }

    let raw = JSON.stringify({
      name: this.state.newName,
      user: this.state.newUsername,
      password: this.state.newPassword,
      email: this.state.newEmail,
      idstaff: this.props.idstaff,
      userxteam: userxteam_data,
    });

    let reqOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    this.setState({ loading: true });

    fetch(window.env.RegisterNewUser, reqOptions)
      .then((response) => response.json())
      .then((data) => {
        if (!data.hasOwnProperty("error")) {
          //user added to team
          this.setState({
            error: false,
            userCreated: true,
            addedToTeam: true,
            loading: false,
          });
        } else {
          //errors returned, user created but not added to any team

          this.setState({
            error: true,
            userCreated: false,
            addedToTeam: false,
            loading: false,
          });
        }
      });
  }

  componentWillMount() {
    this.props.teams.map((team) => {
      if (team.id === this.props.toTeam) {
        this.setState({ teamName: team.name });
      }
    });
  }
  getModalContent() {
    if (
      !this.state.error &&
      !this.state.userCreated &&
      !this.state.addedToTeam
    ) {
      //user yet to create
      return (
        <div>
          <CreateUserForm
            name={this.state.newName}
            newNameChange={() => this.newNameChange.bind(this)}
            email={this.state.newEmail}
            newEmailChange={() => this.newEmailChange.bind(this)}
            username={this.state.newUsername}
            newUsernameChange={() => this.newUsernameChange.bind(this)}
            password={this.state.newPassword}
            newPassChange={() => this.newPassChange.bind(this)}
            linkWeb={this.state.newLinkWeb}
            newLinkWebChange={() => this.newLinkWebChange.bind(this)}
            org={this.state.newOrg}
            newOrgChange={() => this.newOrgChange.bind(this)}
            roles={this.props.roles}
            selectRole={() => this.selectRole.bind(this)}
            loggedUserRoleID={this.props.loggedUserRoleID}
          />
          <p>Per continuare, compila tutti i campi segnati con *</p>
        </div>
      );
    } else if (
      this.state.error &&
      !this.state.userCreated &&
      !this.state.addedToTeam
    ) {
      //error, user not created nor added to team
      if (this.state.userDuplicateKey) {
        return (
          <ErrorMessage
            header="Errore"
            message="Utente non creato perchè esiste già un utente con la stessa mail o username inserito"
            hidden={false}
          />
        );
      } else {
        return (
          <ErrorMessage
            header="Errore"
            message="Utente non creato per un errore, riprova più tardi o contatta il supporto"
            hidden={false}
          />
        );
      }
    } else if (
      this.state.error &&
      this.state.userCreated &&
      !this.state.addedToTeam
    ) {
      //error, user created but non added to team
      return (
        <ErrorMessage
          header="Errore"
          message="Utente creato ma non aggiunto al team per un errore interno, puoi farlo manualmente con la scheda Aggiungi Utente"
          hidden={false}
        />
      );
    } else if (
      !this.state.error &&
      this.state.userCreated &&
      this.state.addedToTeam
    ) {
      //positive, user created and added to team
      return (
        <PositiveMessage
          header="Perfetto!"
          message="Utente creato e aggiunto al team, tutto ok :)"
          hidden={false}
        />
      );
    } else return <div></div>;
  }
  getButtonsLayout() {
    //used to render the correct button configuration
    if (
      !this.state.error &&
      !this.state.userCreated &&
      !this.state.addedToTeam
    ) {
      //user yet to create
      return (
        <div>
          <Button negative onClick={() => this.props.closeModal()}>
            Annulla
          </Button>
          <Button
            positive
            onClick={() => this.createUser()}
            disabled={
              !this.state.newName ||
              !this.state.newEmail ||
              !this.state.newUsername ||
              !this.state.newPassword ||
              !this.state.newRole
            }
            loading={this.state.loading}
          >
            Crea Utente
          </Button>
        </div>
      );
    } else if (
      !this.state.error &&
      this.state.userCreated &&
      this.state.addedToTeam
    ) {
      //user created
      return (
        <Button positive onClick={() => this.props.closeModal()}>
          Finito!
        </Button>
      );
    } else {
      //error
      return (
        <Button negative onClick={() => this.props.closeModal()}>
          Continua
        </Button>
      );
    }
  }
  render() {
    let contentLayout = this.getModalContent();
    let buttonsLayout = this.getButtonsLayout();
    return (
      <Modal
        closeIcon="close"
        open={this.props.openModal}
        onClose={this.props.closeModal}
      >
        <Modal.Header>
          Creazione di nuovo utente per il team {this.state.teamName}
          <Popup
            trigger={<Icon name="help" style={{ float: "right" }} />}
            content={
              "Creazione di un nuovo utente, una volta creato verrà immediatamente aggiunto al team " +
              this.state.teamName
            }
          />
        </Modal.Header>
        <Modal.Content>{contentLayout}</Modal.Content>
        <Modal.Actions>{buttonsLayout}</Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    idstaff: state.user.idstaff,
    loggedUserRoleID: state.user.role_id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateUserModal);



// WEBPACK FOOTER //
// ./src/administration/containers/CreateUserModal.js